// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"488": "78ad041e41676f46","757": "041200bb13dc8153",}[chunkId] + ".js"
}